module.exports = __webpack_public_path__ + "img/bgc.b3437fc9.png";